module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxwYXRoIGQ9Ik0xNSAwYTE1IDE1IDAgMSAwIDE1IDE1QTE1IDE1IDAgMCAwIDE1IDB6bTMuOCAyMC40My0zLjgtMy44LTMuOCAzLjhhMS4xNTMgMS4xNTMgMCAxIDEtMS42My0xLjYzbDMuOC0zLjgtMy44LTMuOGExLjE1MyAxLjE1MyAwIDAgMSAxLjYzLTEuNjNsMy44IDMuOCAzLjgtMy44YTEuMTUzIDEuMTUzIDAgMCAxIDEuNjMgMS42M2wtMy44IDMuOCAzLjggMy44YTEuMTU4IDEuMTU4IDAgMCAxIDAgMS42MyAxLjE0NSAxLjE0NSAwIDAgMS0xLjYzIDB6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/company/ranking/ic_close.svg
// module id = G5v/
// module chunks = 1